import FilterDialog from './Dialog';
import FilterButton from '../../../../../filter/FilterButton';
import { useSelector } from 'react-redux';

//TODO: Move this to a generic component
const FilterUsers = ({ disabled = false, dataRoles = [], dataYears = [], module = '' }) => {
  const open = useSelector((state) => state?.filter?.[module]?.open || false);

  return (
    <>
      <FilterButton module={module} keysFilter={['yearLevelId', 'rolesId']} disabled={disabled} keepReload={false} />
      {open && !disabled && <FilterDialog dataRoles={dataRoles} dataYears={dataYears} module={module} />}
    </>
  );
};
export default FilterUsers;
